import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import OutlinedInput from "@mui/material/OutlinedInput";
import Backdropcircle from "../Loading/Backdrop";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

//
const RECOVER = process.env.REACT_APP_API_APPOINTMENTEMAILRECORVER;

function ForgotPassword({ open, handleClose, ...other }) {
  const [openBackdropcircle, setOpenBackdropcircle] = React.useState(false);
  // Messeger
  const [openMesseger, setOpenMesseger] = React.useState("");
  const [Messeger, setMesseger] = React.useState("");
  const [StatusMesseger, setStatusMesseger] = React.useState("");
  //
  const [email, setEmail] = React.useState(false);

  const handleSubmitEmail = async (event) => {
    setOpenBackdropcircle(true);
    setOpenMesseger(false);

    // event.preventDefault();
    // Capturar el valor del email del input
    const emailValue = event.target.email.value;
    console.log("Email capturado:", emailValue);
    setEmail(emailValue); //

    const datePost = {
      email: emailValue,
    };

    try {
      //
      const jsonpass = {
        method: "POST",
        body: JSON.stringify(datePost),
      };
      //
      const respass = await fetch(`${other.url}${RECOVER}`, jsonpass);
      const res_pass = await respass.json();
      //
      if (respass.status === 200) {
        //
        console.log(res_pass);
        //
        setOpenMesseger(true);
        setMesseger('¡Perfecto! El código ha sido enviado con éxito.');
        // setMesseger(res_pass.message);
        setStatusMesseger("success");
        setOpenBackdropcircle(false);
        //
        window.setTimeout(() => {
          handleClose();
          window.location.reload();
        }, 2000);
        //
      } else {
        //
        console.log(res_pass);
        setOpenBackdropcircle(false);
        setOpenMesseger(true);
        setMesseger(res_pass.error);
        setStatusMesseger("error");
        //
      }
    } catch (error) {
      //
      setOpenBackdropcircle(false);
      setOpenMesseger(true);
      setMesseger('Ocurrio un error, intente mas tarde.');
      setStatusMesseger("error");
      //
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: handleSubmitEmail,
        sx: { backgroundImage: "none" },
      }}
    >
      {openBackdropcircle && <Backdropcircle />}

      <DialogTitle>Recordar código</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}
      >
        <DialogContentText>
          Por favor, ingresa el correo electrónico con el que te registraste y
          te recordaremos el código.
        </DialogContentText>
        <OutlinedInput
          autoFocus
          required
          margin="dense"
          id="email"
          name="email"
          label="Correo para recordar"
          placeholder="Recordar tu correo"
          type="email"
          fullWidth
        />
        {openMesseger && (
          <>
            <Alert variant="filled" severity={StatusMesseger}>
              <AlertTitle>{Messeger}</AlertTitle>
            </Alert>
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>Cerrar</Button>
        <Button variant="contained" type="submit">
          Recordar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ForgotPassword.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ForgotPassword;
